/**
 * コードマスタの種別
 */
export const CODE_MASTER_TYPE = {
  GENDER: 'gender',
  PAYMENT_METHOD_AT_RESERVATION: 'paymentMethodAtReservation',
  PAYMENT_METHOD_IN_VEHICLE: 'paymentMethodInVehicle',
  WAYPOINT_TYPE: 'waypointType',
  RESIDENCE_FLAG: 'residenceFlag',
  LICENSE_TYPE: 'licenseType',
  RESERVATION_STATUS: 'reservationStatus',
  REGISTRANT_TYPE: 'registrantType',
  RESERVATION_TIMING_TYPE: 'reservationTimingType',
  ALLOW_RIDE_SHARE: 'allowRideShare',
};

/**
 * コードマスタのコード
 */
export const CODE_MASTER_CODE = {
  // 男性
  gender_1: '1',
  // 女性
  gender_2: '2',
  // 回答しない
  gender_3: '3',
  // 車内で支払う
  paymentMethodAtReservation_1: '1',
  // オンライン決済
  paymentMethodAtReservation_2: '2',
  // 現金
  paymentMethodInVehicle_1: '1',
  // クレジットカード
  paymentMethodInVehicle_2: '2',
  // 電子決済
  paymentMethodInVehicle_3: '3',
  // その他
  paymentMethodInVehicle_4: '4',
  // QR決済
  paymentMethodInVehicle_5: '5',
  // 交通系IC
  paymentMethodInVehicle_6: '6',
  // 停留所
  waypointType_1: '1',
  // 自宅
  waypointType_2: '2',
  // 居住無し
  residenceFlag_0: '0',
  // 居住有り
  residenceFlag_1: '1',
  // 一種
  licenseType_1: '1',
  // 二種
  licenseType_2: '2',
  // 予約失敗
  reservationStatus_1: '1',
  // 予約完了
  reservationStatus_2: '2',
  // 予約キャンセル（締切前）
  reservationStatus_3: '3',
  // 予約キャンセル（締切後）
  reservationStatus_4: '4',
  // 配車中
  reservationStatus_5: '5',
  // 車両到着済
  reservationStatus_6: '6',
  // 乗車中
  reservationStatus_7: '7',
  // 降車完了
  reservationStatus_8: '8',
  // ドライバキャンセル
  reservationStatus_9: '9',
  // 締切前オペレータキャンセル（ドライバ管理者）
  reservationStatus_10: '10',
  // 締切後オペレータキャンセル（ドライバ管理者）
  reservationStatus_11: '11',
  // 締切前オペレータキャンセル（サービス事業者）
  reservationStatus_12: '12',
  // 締切後オペレータキャンセル（サービス事業者）
  reservationStatus_13: '13',
  // システムキャンセル
  reservationStatus_14: '14',
  // オファリング中
  reservationStatus_15: '15',
  // オファリング期限切れ
  reservationStatus_16: '16',
  // 本人
  registrantType_0: '1',
  // 管理者
  registrantType_1: '2',
  // 事前申込
  reservationTimingType_1: '1',
  // 直前申込
  reservationTimingType_2: '2',
  // 相乗りを許可する
  allowRideShare_1: '1',
  // 相乗りを許可しない
  allowRideShare_2: '2',
};
